import CommonUser from '../../../models/commonUser'
export default class NoticeItem {
    /**
     * @type {string}
     * @memberof NoticeItem
     * @name 类型ID
     */
    public categoryId: string;
    /**
     * @type {string}
     * @memberof NoticeItem
     * @name 类型名称
     */
    public categoryName: string;
    /**
     * @type {string}
     * @memberof NoticeItem
     * @name 等级ID
     */
    public levelId: string;
    /**
     * @type {string}
     * @memberof NoticeItem
     * @name 等级名称
     */
    public levelName: string;
    /**
     * @type {string}
     * @memberof NoticeItem
     * @name 等级颜色
     */
    public levelColor: string;
    /**
     * @type {boolean}
     * @memberof NoticeItem
     * @name 是否需要已读确认
     */
    public needReplayFlag: boolean;
    /**
     * @type {string}
     * @memberof NoticeItem
     * @name 通知ID
     */
    public noticeId: string;
    /**
     * @type {boolean}
     * @memberof NoticeItem
     * @name 有否含有附件
     */
    public attachmentFlag: boolean;
    /**
     * @type {boolean}
     * @memberof NoticeItem
     * @name readFlag
     */
    public readFlag: boolean;
    /**
     * @type {string}
     * @memberof NoticeItem
     * @name 发送组织ID
     */
    public sendOrgId: string;
    /**
     * @type {string}
     * @memberof NoticeItem
     * @name 发送组织名称
     */
    public sendOrgName: string;
    /**
     * @type {string}
     * @memberof NoticeItem
     * @name 发送时间
     */
    public sendTime: string;
    /**
     * @type {CommonUser}
     * @memberof NoticeItem
     * @name 发送人
     */
    public sendUser: CommonUser;
    /**
     * @type {string}
     * @memberof NoticeItem
     * @name 标题
     */
    public title: string;
    /**
     * @type {string}
     * @memberof NoticeItem
     * @name 回复内容
     */
    public answerContent: string;
    /**
     * @type {string}
     * @memberof NoticeItem
     * @name 回复日期
     */
    public answerDate: string;
    /**
     * @type {boolean}
     * @memberof NoticeItem
     * @name 是否需要回复
     */
    public needAnswerFlag: boolean;
    /**
     * @type {string}
     * @memberof NoticeItem
     * @name 通知类型
     */
    public noticeType: string;
    /**
     * @type {boolean}
     * @memberof NoticeItem
     * @name 表单填报
     */
    public needFormFlag: boolean;
    constructor({
        categoryId = '',
        categoryName = '',
        levelId = '',
        levelName = '',
        levelColor = '',
        needReplayFlag = false,
        noticeId = '',
        readFlag = true,
        attachmentFlag = false,
        sendOrgId = '',
        sendOrgName = '',
        sendTime = '',
        sendUser = new CommonUser(),
        title = '',
        answerContent = '',
        answerDate = '',
        needAnswerFlag = true,
        noticeType = '',
        needFormFlag = false
    } = {}) {
        this.categoryId = categoryId
        this.categoryName = categoryName
        this.levelId = levelId
        this.levelName = levelName
        this.levelColor = levelColor
        this.needReplayFlag = needReplayFlag
        this.noticeId = noticeId
        this.readFlag = readFlag
        this.attachmentFlag = attachmentFlag
        this.sendOrgId = sendOrgId
        this.sendOrgName = sendOrgName
        this.sendUser = sendUser
        this.sendTime = sendTime
        this.title = title
        this.answerContent = answerContent
        this.answerDate = answerDate
        this.needAnswerFlag = needAnswerFlag
        this.noticeType = noticeType
        this.needFormFlag = needFormFlag
    }
}